import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import { Sidenav } from "./sidenav"
import { GoogleAds, DisplaySidenavHomeAds } from "./googleads"
import { Footer } from "./footer"
import { AboutWebsite } from "./aboutwebsite"

const Layout = ({ location, children }) => {
  const data = useStaticQuery(graphql`
    query allCategoryQueryAndSiteTitleQuery {
      allMdx(filter: { frontmatter: { shorts: { eq: false } } }) {
        edges {
          node {
            frontmatter {
              category
            }
          }
        }
      }
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const path = location?.pathname || ""

  const categories = data?.allMdx?.edges?.map(
    res => res.node.frontmatter.category
  )

  const uniqueCategories = Array.from(new Set(categories))

  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        categories={uniqueCategories || []}
      />
      <div className="layout-grid">
        <main className="middle">{children}</main>
        <Sidenav>
          <DisplaySidenavHomeAds />
          <AboutWebsite />
          <GoogleAds path={path} />
        </Sidenav>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
